import { debugFactory } from '@iva/debugger';
const config = {
    name: 'utils',
    fColor: 'white',
    bColor: '#cc0044',
};
const debug = debugFactory(config);
export { debug };
